import { WithdrawalsLimitsRecord } from '@types';

import { WithdrawalsSetLimitsLimitAmountReducer } from './types';

export const withdrawalsSetLimitsLimitAmountReducer: WithdrawalsSetLimitsLimitAmountReducer =
  (state, action) => {
    const { limitId, limitAmount, range } = action.payload;

    const limitToUpdate = state.withdrawalsLimitsProcessedItems?.[limitId];

    if (!limitToUpdate) {
      return state;
    }

    const updatedItem: WithdrawalsLimitsRecord = {
      [limitId]: {
        ...limitToUpdate,
        [range]: limitAmount,
      },
    };

    return {
      ...state,
      withdrawalsLimitsProcessedItems: {
        ...state.withdrawalsLimitsProcessedItems,
        ...updatedItem,
      },
    };
  };
